export const GENERIC_LMS_LOGIN = 'GENERIC_LMS_LOGIN';
export const GENERIC_LMS_LOGIN_ERROR = 'GENERIC_LMS_LOGIN_ERROR';
export const GENERIC_LMS_LOAD_H5P_SETTINGS = 'GENERIC_LMS_LOAD_H5P_SETTINGS';
export const GENERIC_LMS_LOAD_H5P_SETTINGS_ERROR = 'GENERIC_LMS_LOAD_H5P_SETTINGS_ERROR';
export const SAFARI_MONTAGE_LOAD_PUBLISH_TOOL = 'SAFARI_MONTAGE_LOAD_PUBLISH_TOOL';
export const SAFARI_MONTAGE_LOAD_PUBLISH_TOOL_ERROR = 'SAFARI_MONTAGE_LOAD_PUBLISH_TOOL_ERROR';
export const CLOSE_SAFARI_MONTAGE_TOOL = 'CLOSE_SAFARI_MONTAGE_TOOL';
